const english = {
    navbar: {
      about: 'About',
      contact: 'Contact',
      help: 'Help',
    },
    hero: {
      title: 'Welcome to Our Website',
      subtitle: 'We are glad to have you here'
    },
    footer: {
      address: '123 Main St, Anytown, USA',
      phone: 'Call us: (123) 456-7890',
      email: 'Email us: info@example.com'
    }
  };
  
  export default english;
  